module.exports = __webpack_public_path__ + "static/media/activity.0c32a7eb.png";